/* Komodin kt- vitrin çalışma zamanı (tema sahibi kod). Kaynak site betikleri kullanılmaz.
   Modüller data-kt-* öznitelikleriyle bağlanır. */
(function () {
  'use strict';
  var d = document, w = window;
  var KT = (w.KT = w.KT || {});
  var SFT = '6bdafa8529da80186745bd92aba60503', SFURL = '/api/2025-01/graphql.json';

  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }
  KT.qs = qs; KT.qsa = qsa;

  /* ---------- para biçimi ---------- */
  KT.money = function (amount) {
    var n = Number(amount || 0);
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  };

  /* ---------- kargo planı (CA-52): kesim günü + en geç kargo günü; ürün ve sepet aynı hesabı kullanır ----------
     Kesim günü: bugün iş günü (hafta içi, tatil değil) ve saat < kesim ise bugün, değilse sonraki iş günü.
     Sayaç kesim gününün kesim saatine sayar; kargo günü kesim gününden 'gun' iş günü sonra (gun = hazırlık en çok, varsayılan 1;
     0 = aynı gün). 'when': bugün / yarın / gün adı. Türkiye UTC+3 (yaz saati yok).
     Birim testi: artifacts/candidate-probes/stage-tur3/kargo-plan.test.mjs (aşağıdaki işaretler arasını okur). */
  /* kargoPlan:start */
  KT.kargoPlan = function (now, cutoff, hol, gun) {
    var TZ = 3 * 3600000, DAY = 86400000, NOON = 12 * 3600000;
    var names = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
    hol = hol || []; gun = (gun === 0 || gun > 0) ? gun : 1;
    function ymd(t) { var y = new Date(t + TZ); return y.getUTCFullYear() + '-' + ('0' + (y.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + y.getUTCDate()).slice(-2); }
    function dow(d0) { return new Date(d0 + NOON + TZ).getUTCDay(); }
    function isWork(d0) { var wd = dow(d0); return wd !== 0 && wd !== 6 && hol.indexOf(ymd(d0 + NOON)) < 0; }
    var x = new Date(now + TZ), day0 = Date.UTC(x.getUTCFullYear(), x.getUTCMonth(), x.getUTCDate()) - TZ;
    var cut = null, ship = null, k;
    for (k = 0; k < 60; k++) { if (isWork(day0 + k * DAY) && day0 + k * DAY + cutoff * 3600000 > now) { cut = day0 + k * DAY; break; } }
    if (cut === null) return null;
    if (gun === 0) ship = cut;
    for (var n = 0, k = 1; gun > 0 && k < 60; k++) { if (isWork(cut + k * DAY) && ++n === gun) { ship = cut + k * DAY; break; } }
    if (ship === null) return null;
    var fark = Math.round((ship - day0) / DAY);
    return { deadline: cut + cutoff * 3600000, cutDay: ymd(cut + NOON), shipDay: ymd(ship + NOON), shipName: names[dow(ship)],
             when: fark === 0 ? 'bugün' : (fark === 1 ? 'yarın' : names[dow(ship)]) };
  };
  /* kargoPlan:end */

  /* ---------- kaydırma kilidi ---------- */
  var lockCount = 0;
  KT.lock = function () { lockCount++; d.documentElement.classList.add('kt-kilit'); };
  KT.unlock = function () { lockCount = Math.max(0, lockCount - 1); if (!lockCount) d.documentElement.classList.remove('kt-kilit'); };

  /* ---------- başlık yüksekliği (sabit mobil başlık için) ---------- */
  function headerHeight() {
    var h = qs('[data-kt-header]');
    if (!h) return;
    var fixed = getComputedStyle(h).position === 'fixed';
    var val = h.offsetHeight;
    if (!fixed) {
      var nav = qs('[data-kt-navbar]');
      val = h.offsetHeight;
      if (nav && nav.offsetParent) val = h.offsetHeight;
    }
    d.documentElement.style.setProperty('--header-height', val + 'px');
  }

  /* ---------- Storefront sepet ---------- */
  var CF = 'fragment C on Cart{id checkoutUrl totalQuantity cost{subtotalAmount{amount} totalAmount{amount}} discountAllocations{discountedAmount{amount} ... on CartAutomaticDiscountAllocation{title}} lines(first:100){nodes{id quantity cost{totalAmount{amount} subtotalAmount{amount}} discountAllocations{discountedAmount{amount} ... on CartAutomaticDiscountAllocation{title}} merchandise{... on ProductVariant{id title availableForSale quantityAvailable price{amount} compareAtPrice{amount} image{url altText} selectedOptions{name value} product{id title handle vendor featuredImage{url} satici: metafield(namespace:"komodin",key:"satici"){reference{... on Metaobject{handle ad: field(key:"ad"){value}}}} collections(first:30){nodes{handle}}}}}}}}';
  KT.sf = function (query, vars) {
    return fetch(SFURL, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SFT, 'Accept': 'application/json' }, body: JSON.stringify({ query: query, variables: vars || {} }) })
      .then(function (r) { return r.json(); }).then(function (j) { return j.data; });
  };
  KT.cartFragment = CF;
  KT.cartId = function () { try { return localStorage.getItem('mk_cart_id') || ''; } catch (e) { return ''; } };
  KT.setCartId = function (v) { try { if (v) localStorage.setItem('mk_cart_id', v); else localStorage.removeItem('mk_cart_id'); } catch (e) {} };
  KT.getCart = function () {
    var id = KT.cartId();
    if (!id) return Promise.resolve(null);
    return KT.sf('query($id:ID!){cart(id:$id){...C}}' + CF, { id: id }).then(function (dd) {
      var c = dd && dd.cart; if (!c) KT.setCartId(''); return c || null;
    }).catch(function () { return null; });
  };
  KT.addToCart = function (variantGid, qty) {
    var id = KT.cartId();
    var line = [{ merchandiseId: variantGid, quantity: qty || 1 }];
    var create = function () {
      return KT.sf('mutation($l:[CartLineInput!]!){cartCreate(input:{lines:$l}){cart{...C} userErrors{message}}}' + CF, { l: line })
        .then(function (dd) { var x = dd && dd.cartCreate; return { cart: x && x.cart, errors: (x && x.userErrors) || [] }; });
    };
    var p = id ? KT.sf('mutation($id:ID!,$l:[CartLineInput!]!){cartLinesAdd(cartId:$id,lines:$l){cart{...C} userErrors{message}}}' + CF, { id: id, l: line })
      .then(function (dd) { var x = dd && dd.cartLinesAdd; if (x && x.cart) return { cart: x.cart, errors: x.userErrors || [] }; KT.setCartId(''); return create(); }) : create();
    return p.then(function (res) { if (res.cart) { KT.setCartId(res.cart.id); KT.renderCount(res.cart); d.dispatchEvent(new CustomEvent('kt:cart', { detail: res.cart })); } return res; });
  };
  KT.updateLine = function (lineId, qty) {
    var id = KT.cartId(); if (!id) return Promise.resolve(null);
    return KT.sf('mutation($id:ID!,$l:[CartLineUpdateInput!]!){cartLinesUpdate(cartId:$id,lines:$l){cart{...C} userErrors{message}}}' + CF, { id: id, l: [{ id: lineId, quantity: qty }] })
      .then(function (dd) { var x = dd && dd.cartLinesUpdate; var c = x && x.cart; if (c) { KT.renderCount(c); d.dispatchEvent(new CustomEvent('kt:cart', { detail: c })); } return c; });
  };
  KT.removeLines = function (lineIds) {
    var id = KT.cartId(); if (!id) return Promise.resolve(null);
    return KT.sf('mutation($id:ID!,$l:[ID!]!){cartLinesRemove(cartId:$id,lineIds:$l){cart{...C} userErrors{message}}}' + CF, { id: id, l: lineIds })
      .then(function (dd) { var x = dd && dd.cartLinesRemove; var c = x && x.cart; if (c) { KT.renderCount(c); d.dispatchEvent(new CustomEvent('kt:cart', { detail: c })); } return c; });
  };
  KT.renderCount = function (cart) {
    var n = (cart && cart.totalQuantity) || 0;
    qsa('[data-kt-cart-count]').forEach(function (b) {
      b.textContent = n; b.classList.toggle('hidden', n <= 0); b.classList.toggle('flex', n > 0);
    });
  };

  /* ---------- geri bildirim (sepete ekleme): gap-fill C2 — sağ üst toast, 0.35 s giriş, 2000 ms, 0.4 s çıkış ---------- */
  KT.toast = function (msg, isError) {
    var box = qs('[data-kt-toast-box]');
    if (!box) { box = d.createElement('div'); box.setAttribute('data-kt-toast-box', ''); box.className = 'kt-toast-kutu'; d.body.appendChild(box); }
    var t = d.createElement('div');
    t.className = 'kt-toast' + (isError ? ' kt-toast--hata' : '');
    t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
    t.innerHTML = '<span class="kt-toast-ikon" aria-hidden="true">' + (isError
      ? '<svg viewBox="0 0 20 20" width="20" height="20"><circle cx="10" cy="10" r="10" fill="#ff4b4b"/><path d="M6.5 6.5l7 7M13.5 6.5l-7 7" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>'
      : '<svg viewBox="0 0 20 20" width="20" height="20"><circle cx="10" cy="10" r="10" fill="#61d345"/><path d="M5.8 10.3l2.8 2.8 5.6-5.8" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') + '</span><span class="kt-toast-metin"></span>';
    t.querySelector('.kt-toast-metin').textContent = msg;
    box.appendChild(t);
    setTimeout(function () { t.classList.add('is-leaving'); setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 1000); }, isError ? 4000 : 2000);
  };

  /* yönlendirmeli eklemede bildirimi bir sonraki sayfada (sepet) aynı kutuda göster (C2) */
  function pendingToast() {
    try {
      var raw = sessionStorage.getItem('kt_toast'); if (!raw) return;
      sessionStorage.removeItem('kt_toast');
      var o = JSON.parse(raw); if (o && o.msg && Date.now() - (o.t || 0) < 15000) KT.toast(o.msg);
    } catch (e) {}
  }

  /* ---------- sepete ekle formları (kart / ürün) ---------- */
  on(d, 'submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-kt-add]');
    if (!f) return;
    e.preventDefault();
    var idInp = f.querySelector('[name=id]'); if (!idInp || !idInp.value) return;
    var qInp = f.querySelector('[name=quantity]'); var qty = qInp ? (parseInt(qInp.value, 10) || 1) : 1;
    var btn = f.querySelector('[type=submit]'); var html = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); if (btn.hasAttribute('data-kt-busy-label')) btn.textContent = btn.getAttribute('data-kt-busy-label'); }
    var redirect = f.getAttribute('data-kt-redirect');
    KT.toast('Ürün sepete eklendi');
    KT.addToCart('gid://shopify/ProductVariant/' + idInp.value, qty).then(function (res) {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = html; }
      if (!res.cart) { KT.toast((res.errors[0] && res.errors[0].message) || 'Ürün sepete eklenemedi.', true); return; }
      if (redirect) { try { sessionStorage.setItem('kt_toast', JSON.stringify({ msg: 'Ürün sepete eklendi', t: Date.now() })); } catch (err) {} location.href = redirect; }
    }).catch(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = html; } KT.toast('Bağlantı hatası, lütfen tekrar deneyin.', true); });
  });

  /* ---------- favoriler (komodin-fav.js ile aynı anahtar: mk_fav) ---------- */
  function favs() { try { return JSON.parse(localStorage.getItem('mk_fav') || '[]'); } catch (e) { return []; } }
  function markFavs() {
    var ids = favs().map(function (x) { return String(x.id); });
    qsa('[data-kt-fav]').forEach(function (b) {
      var onFav = ids.indexOf(String(b.getAttribute('data-id'))) >= 0;
      b.classList.toggle('kt-kart-kalp--dolu', onFav); b.setAttribute('aria-pressed', onFav ? 'true' : 'false');
    });
  }
  KT.markFavs = markFavs;
  on(d, 'click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kt-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var id = String(b.getAttribute('data-id')), l = favs(), idx = -1;
    for (var i = 0; i < l.length; i++) if (String(l[i].id) === id) { idx = i; break; }
    if (idx >= 0) l.splice(idx, 1);
    else l.push({ id: id, h: b.getAttribute('data-h'), t: b.getAttribute('data-t'), p: b.getAttribute('data-p'), cp: b.getAttribute('data-cp'), img: b.getAttribute('data-img'), u: b.getAttribute('data-u') });
    try { localStorage.setItem('mk_fav', JSON.stringify(l)); } catch (err) {}
    markFavs();
  });

  /* ---------- mega menü ---------- */
  function initMega() {
    var trig = qs('[data-kt-mega-trigger]'), panel = qs('[data-kt-mega-panel]');
    if (!trig || !panel) return;
    function setCat(i) {
      qsa('[data-kt-mega-cat]', panel).forEach(function (b) {
        var act = b.getAttribute('data-kt-mega-cat') === String(i);
        b.classList.toggle('is-active', act); b.setAttribute('aria-expanded', act ? 'true' : 'false');
      });
      qsa('[data-kt-mega-pane]', panel).forEach(function (p) {
        var act = p.getAttribute('data-kt-mega-pane') === String(i);
        p.classList.toggle('hidden', !act); p.classList.toggle('flex', act);
      });
    }
    function open() {
      closeSearch();
      panel.classList.remove('invisible'); panel.classList.add('is-open');
      trig.setAttribute('aria-expanded', 'true'); trig.classList.add('is-open');
    }
    function close() {
      panel.classList.add('invisible'); panel.classList.remove('is-open');
      trig.setAttribute('aria-expanded', 'false'); trig.classList.remove('is-open');
    }
    KT.closeMega = close;
    on(trig, 'click', function (e) { e.preventDefault(); if (!panel.classList.contains('is-open')) open(); else close(); });
    qsa('[data-kt-mega-cat]', panel).forEach(function (b) {
      var i = b.getAttribute('data-kt-mega-cat');
      on(b, 'mouseenter', function () { setCat(i); });
      on(b, 'focus', function () { setCat(i); });
      on(b, 'click', function () { setCat(i); });
    });
    on(d, 'click', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (panel.contains(e.target) || trig.contains(e.target)) return;
      close();
    });
    on(d, 'keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) { close(); trig.focus(); } });
  }

  /* ---------- arama önerileri ---------- */
  var searchTimer = null, bestLoaded = false;
  function padRows(el, pad) { qsa('.kt-pad', el).forEach(function (r) { r.classList.add(pad); }); }
  function loadBest() {
    if (bestLoaded) return; bestLoaded = true;
    var holders = qsa('[data-kt-search-best]'); if (!holders.length) return;
    var url = holders[0].getAttribute('data-url') || '/collections/all?sort_by=best-selling';
    url += (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=kt-search-best';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = d.createElement('div'); tmp.innerHTML = html;
      var list = tmp.querySelector('.kt-oneri-liste');
      holders.forEach(function (h) { h.innerHTML = list ? list.outerHTML : ''; padRows(h, h.getAttribute('data-pad') || 'px-6'); });
    }).catch(function () { bestLoaded = false; });
  }
  function suggest(root, term) {
    var focus = qs('[data-kt-search-focus]', root), res = qs('[data-kt-search-results]', root), body = qs('[data-kt-search-results-body]', root);
    if (!term) { if (focus) focus.classList.remove('kt-gizli'); if (res) res.classList.add('kt-gizli'); return; }
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      var u = '/search/suggest?q=' + encodeURIComponent(term) + '&resources[type]=product,query&resources[limit]=5&resources[options][unavailable_products]=last&section_id=kt-predictive-search';
      fetch(u).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var c = tmp.querySelector('.kt-oneri-sonuc');
        if (body) { body.innerHTML = c ? c.outerHTML : ''; padRows(body, root.getAttribute('data-pad') || (root.hasAttribute('data-kt-mobile-search') ? 'px-4' : 'px-6')); }
        if (focus) focus.classList.add('kt-gizli'); if (res) res.classList.remove('kt-gizli');
      }).catch(function () {});
    }, 200);
  }
  function closeSearch() {
    var dd = qs('[data-kt-search-dropdown]'); if (dd) dd.classList.add('kt-gizli');
  }
  KT.closeSearch = closeSearch;
  function initSearch() {
    var input = qs('[data-kt-search-input]'), dd = qs('[data-kt-search-dropdown]'), root = qs('[data-kt-search-root]');
    if (input && dd) {
      /* kaynak gibi body altında (portal) ve fixed: arama kutusunun 8 px altı, kutu genişliği.
         Başlık satırının overflow:hidden'ı ve kategori çubuğunun katmanı kutuyu örtmesin. */
      var form = input.closest('form') || input;
      if (dd.parentNode !== d.body) d.body.appendChild(dd);
      var placeDD = function () { var r = form.getBoundingClientRect(); dd.style.left = r.left + 'px'; dd.style.top = (r.bottom + 8) + 'px'; dd.style.width = r.width + 'px'; };
      var rafDD = 0;
      var followDD = function () { if (dd.classList.contains('kt-gizli') || rafDD) return; rafDD = w.requestAnimationFrame(function () { rafDD = 0; placeDD(); }); };
      on(w, 'scroll', followDD, { passive: true }); on(w, 'resize', followDD);
      var openDD = function () { if (KT.closeMega) KT.closeMega(); placeDD(); dd.classList.remove('kt-gizli'); loadBest(); suggest(dd, input.value.trim()); };
      on(input, 'focus', openDD);
      on(input, 'click', openDD);
      on(input, 'input', function () { placeDD(); dd.classList.remove('kt-gizli'); suggest(dd, input.value.trim()); });
      on(d, 'click', function (e) { if (root && !root.contains(e.target) && !dd.contains(e.target)) closeSearch(); });
      on(input, 'keydown', function (e) { if (e.key === 'Escape') { closeSearch(); input.blur(); } });
    }
    /* mobil tam ekran arama */
    var ov = qs('[data-kt-mobile-search]');
    if (ov) {
      var oi = qs('[data-kt-overlay-input]', ov);
      var openOv = function (e) { if (e) e.preventDefault(); if (!ov.classList.contains('kt-gizli')) return; ov.classList.remove('kt-gizli'); KT.lock(); loadBest(); setTimeout(function () { if (oi) oi.focus(); }, 30); };
      var closeOv = function () { ov.classList.add('kt-gizli'); KT.unlock(); };
      KT.openMobileSearch = openOv; KT.closeMobileSearch = closeOv;
      qsa('[data-kt-mobile-search-trigger],[data-kt-mobile-search-open]').forEach(function (t) { on(t, 'click', openOv); on(t, 'focus', function (e) { if (t.tagName === 'INPUT') openOv(e); }); });
      qsa('[data-kt-mobile-search-close]', ov).forEach(function (c) { on(c, 'click', closeOv); });
      if (oi) on(oi, 'input', function () { suggest(ov, oi.value.trim()); });
      on(d, 'keydown', function (e) { if (e.key === 'Escape' && !ov.classList.contains('kt-gizli')) closeOv(); });
    }
  }

  /* ---------- çekmece ---------- */
  function initDrawer() {
    var root = qs('[data-kt-drawer-root]'); if (!root) return;
    var panel = qs('[data-kt-drawer]', root);
    function open(e) { if (e) e.preventDefault(); root.classList.remove('invisible'); root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); KT.lock(); }
    function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); KT.unlock(); setTimeout(function () { if (!root.classList.contains('is-open')) root.classList.add('invisible'); }, 320); }
    KT.openDrawer = open; KT.closeDrawer = close;
    qsa('[data-kt-drawer-open]').forEach(function (b) { on(b, 'click', open); });
    qsa('[data-kt-drawer-close]', root).forEach(function (b) { on(b, 'click', close); });
    qsa('[data-kt-drawer-cat-toggle]', root).forEach(function (b) {
      on(b, 'click', function () {
        var li = b.closest('[data-kt-drawer-cat]'), list = qs('[data-kt-drawer-cat-list]', li);
        var openNow = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', openNow ? 'true' : 'false');
        if (list) list.classList.toggle('hidden', !openNow);
        li.classList.toggle('is-open', openNow);
      });
    });
    on(d, 'keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
    void panel;
  }

  /* ---------- geri düğmesi ---------- */
  function initBack() {
    qsa('[data-kt-back]').forEach(function (b) {
      on(b, 'click', function () {
        var ref = d.referrer; var same = ref && ref.indexOf(location.origin) === 0;
        if (same && history.length > 1) history.back(); else location.href = '/';
      });
    });
  }

  /* ---------- kategori çubuğu: sığmayan ya da sıkışan bağlantıları sondan gizle ----------
     Kaynakta bağlantılar justify-between ile eşit aralıklı (D 9 bağlantı, aralık 21.7 px); aralık 20 px'in altına inmez. */
  var NAV_MIN_GAP = 20;
  function fitNav() {
    var box = qs('[data-kt-nav-links]'); if (!box || !box.offsetParent) return;
    var links = qsa('a', box);
    links.forEach(function (a) { a.classList.remove('kt-nav-gizli'); });
    var cs = getComputedStyle(box), inner = box.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    function visible() { return links.filter(function (a) { return !a.classList.contains('kt-nav-gizli'); }); }
    function gap(v) { if (v.length < 2) return Infinity; var sum = 0; v.forEach(function (a) { sum += a.getBoundingClientRect().width; }); return (inner - sum) / (v.length - 1); }
    var vis = visible();
    while (vis.length > 1 && (box.scrollWidth > box.clientWidth + 1 || gap(vis) < NAV_MIN_GAP)) {
      vis[vis.length - 1].classList.add('kt-nav-gizli'); vis = visible();
    }
  }

  /* ---------- çip listesi satır sınırı: [data-kt-chip-rows="N"] ilk N satırı gösterir, kalanı "Tümünü gör" çipi açar ---------- */
  function fitChipRows() {
    qsa('[data-kt-chip-rows]').forEach(function (ul) {
      if (ul.hasAttribute('data-kt-chips-open') || !ul.offsetParent) return;
      var max = Number(ul.getAttribute('data-kt-chip-rows')) || 1;
      var items = qsa(':scope > li:not([data-kt-chip-more])', ul), more = qs(':scope > li[data-kt-chip-more]', ul);
      items.forEach(function (li) { li.hidden = false; });
      if (more) more.hidden = true;
      if (!items.length) return;
      var tops = []; items.forEach(function (li) { if (tops.indexOf(li.offsetTop) < 0) tops.push(li.offsetTop); });
      if (tops.length <= max) return;
      var limit = tops.sort(function (a, b) { return a - b; })[max - 1];
      if (!more) {
        more = d.createElement('li'); more.setAttribute('data-kt-chip-more', '');
        var btn = d.createElement('button'); btn.type = 'button';
        btn.className = 'inline-block text-xs md:text-sm font-semibold text-themeDefaultColor bg-white hover:bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5 transition-colors';
        btn.textContent = 'Tümünü gör';
        on(btn, 'click', function () { ul.setAttribute('data-kt-chips-open', ''); qsa(':scope > li', ul).forEach(function (li) { li.hidden = false; }); more.hidden = true; });
        more.appendChild(btn); ul.appendChild(more);
      }
      more.hidden = false;
      items.forEach(function (li) { if (li.offsetTop > limit) li.hidden = true; });
      var vis = items.filter(function (li) { return !li.hidden; });
      while (more.offsetTop > limit && vis.length) { vis.pop().hidden = true; }
    });
  }

  /* ---------- üst çubuk kampanya metni (CA-17): ikinci cümle yalnız bağlantılara çarpmıyorsa ---------- */
  function fitPromo() {
    qsa('[data-kt-promo]').forEach(function (p) {
      var links = qs('[data-kt-utility-links]'); if (!links || !p.offsetParent) return;
      qsa('[data-kt-promo-extra]', p).forEach(function (x) { x.hidden = false; });
      qsa('[data-kt-promo-extra]', p).reverse().forEach(function (x) { if (p.getBoundingClientRect().right + 16 > links.getBoundingClientRect().left) x.hidden = true; });
      p.style.visibility = p.getBoundingClientRect().right + 16 > links.getBoundingClientRect().left ? 'hidden' : '';
    });
  }

  /* ---------- yukarı çık ---------- */
  function initTop() {
    var b = qs('[data-kt-top]'); if (!b) return;
    var th = 300;
    function sc() { var y = w.pageYOffset || d.documentElement.scrollTop || 0; b.classList.toggle('kt-gizli', y <= th); b.classList.toggle('flex', y > th); }
    on(w, 'scroll', sc, { passive: true }); sc();
    on(b, 'click', function () { KT.smoothTop(400); });
  }
  KT.smoothTop = function (dur) {
    var start = w.pageYOffset, t0 = null;
    if (start <= 0) return;
    function step(ts) { if (t0 === null) t0 = ts; var p = Math.min(1, (ts - t0) / dur); var e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2; w.scrollTo(0, Math.round(start * (1 - e))); if (p < 1) w.requestAnimationFrame(step); }
    w.requestAnimationFrame(step);
  }

  /* ---------- SEO metni genişletici (R18/R19): data-kt-seo-toggle ---------- */
  on(d, 'click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kt-seo-toggle]'); if (!btn) return;
    var box = btn.closest('article') || btn.closest('section'); var body = box && box.querySelector('[data-kt-seo-body]'); if (!body) return;
    var fade = body.querySelector('[data-kt-seo-fade]'); var cls = body.getAttribute('data-kt-collapsed-class') || 'max-h-[330px]';
    var open = btn.getAttribute('aria-expanded') === 'true';
    if (!open) { body.style.maxHeight = body.scrollHeight + 'px'; body.classList.remove(cls); if (fade) fade.hidden = true; btn.textContent = 'Daha Az Göster'; btn.setAttribute('aria-expanded', 'true'); }
    else { body.style.maxHeight = ''; body.classList.add(cls); if (fade) fade.hidden = false; btn.textContent = 'Devamını Oku'; btn.setAttribute('aria-expanded', 'false'); }
  });

  /* ---------- paylaş: alt sayfa (C1) ve yerel paylaşım ---------- */
  function copyText(t) {
    function fb() {
      var ta = d.createElement('textarea'); ta.value = t; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0'; d.body.appendChild(ta); ta.select();
      try { d.execCommand('copy'); KT.toast('Bağlantı kopyalandı'); } catch (e) { KT.toast('Bağlantı kopyalanamadı', true); }
      d.body.removeChild(ta);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(function () { KT.toast('Bağlantı kopyalandı'); }, fb); else fb();
  }
  KT.copy = copyText;
  function nativeShare(title, url) {
    if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
    copyText(url);
  }
  KT.share = nativeShare;
  var shareOpen = null;
  function shareSet(sh, open) {
    var panel = qs('[data-kt-share-panel]', sh), bd = qs('.absolute.inset-0[data-kt-share-close]', sh);
    if (open) {
      sh.classList.remove('kt-gizli'); void sh.offsetWidth;
      if (panel) panel.classList.remove('translate-y-full');
      if (bd) { bd.classList.remove('opacity-0'); bd.classList.add('opacity-100'); }
      KT.lock(); shareOpen = sh;
    } else {
      if (panel) panel.classList.add('translate-y-full');
      if (bd) { bd.classList.add('opacity-0'); bd.classList.remove('opacity-100'); }
      setTimeout(function () { if (shareOpen !== sh) sh.classList.add('kt-gizli'); }, 300);
      KT.unlock(); shareOpen = null;
    }
  }
  on(d, 'click', function (e) {
    var t = e.target;
    var ob = t.closest && t.closest('[data-kt-share-open]');
    if (ob) { e.preventDefault(); var sh = qs('[data-kt-share="' + ob.getAttribute('data-kt-share-open') + '"]'); if (sh) shareSet(sh, true); return; }
    var sh2 = t.closest && t.closest('[data-kt-share]'); 
    if (sh2) {
      var url = sh2.getAttribute('data-url') || location.href, text = sh2.getAttribute('data-text') || d.title;
      if (t.closest('[data-kt-share-close]')) { e.preventDefault(); shareSet(sh2, false); return; }
      if (t.closest('[data-kt-share-copy]')) { e.preventDefault(); copyText(url); return; }
      var to = t.closest('[data-kt-share-to]');
      if (to) {
        e.preventDefault();
        var k = to.getAttribute('data-kt-share-to'), href = '';
        if (k === 'whatsapp') href = 'https://wa.me/?text=' + encodeURIComponent(text + ' ' + url);
        else if (k === 'facebook') href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);
        else if (k === 'x') href = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text) + '&url=' + encodeURIComponent(url);
        else { nativeShare(text, url); return; }
        w.open(href, '_blank', 'noopener');
      }
      return;
    }
    var ns = t.closest && t.closest('[data-kt-native-share]');
    if (ns) { e.preventDefault(); nativeShare(ns.getAttribute('data-title') || d.title, ns.getAttribute('data-url') || location.href); }
  });
  on(d, 'keydown', function (e) { if (e.key === 'Escape' && shareOpen) shareSet(shareOpen, false); });

  /* ---------- modül kayıt ---------- */
  KT.modules = KT.modules || [];
  KT.register = function (fn) { KT.modules.push(fn); if (KT._ready) try { fn(); } catch (e) { console.error(e); } };

  function init() {
    headerHeight(); initMega(); initSearch(); initDrawer(); initBack(); initTop(); fitNav(); fitPromo(); fitChipRows(); markFavs(); pendingToast();
    KT.getCart().then(KT.renderCount);
    KT._ready = true;
    KT.modules.forEach(function (fn) { try { fn(); } catch (e) { console.error(e); } });
    var rt; on(w, 'resize', function () { clearTimeout(rt); rt = setTimeout(function () { headerHeight(); fitNav(); fitPromo(); fitChipRows(); }, 120); });
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { headerHeight(); fitNav(); fitPromo(); fitChipRows(); });
  }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
